
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"chart","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M3 22h18"}}),_c('path',{attrs:{"data-name":"Vector","d":"M5.6 8.38H4a1 1 0 00-1 1V18a1 1 0 001 1h1.6a1 1 0 001-1V9.38a1 1 0 00-1-1zM12.8 5.19h-1.6a1 1 0 00-1 1V18a1 1 0 001 1h1.6a1 1 0 001-1V6.19a1 1 0 00-1-1zM20 2h-1.6a1 1 0 00-1 1v15a1 1 0 001 1H20a1 1 0 001-1V3a1 1 0 00-1-1z"}})])])
          )
        }
      }
    